import { OnInit } from '@angular/core';
var ContextConfigurationComponent = /** @class */ (function () {
    function ContextConfigurationComponent() {
    }
    ContextConfigurationComponent.prototype.ngOnInit = function () {
    };
    return ContextConfigurationComponent;
}());
export { ContextConfigurationComponent };
